import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { CLICKED, days, EXIT, months } from '../../../config/constant'
import { playOnTV } from '../../../components/tv-channels/channelController'
import $ from 'jquery'
import { setCurrentTV } from '../../../action/tvChannelAction'
import { setGoHome } from '../../action/homeAction'
import { sendAnalytics } from '../../../action/homeAction'
import {withTranslation} from "react-i18next";
import { playDoorCameraStream as streamChannel } from '../../../JS/playDoorCameraStream';
import { currentWidget, popupOpenClose, setMobileTVPage, setRegPage} from '../../../action/action'
import { fetchChannelList } from '../../../action/tvChannelAction'
import { setChannelData } from '../../action/TVAction2'
import SuccessFailScreen from '../../UI/SuccessFailScreen';
import { getConnectionType, checkIfImageExists, getDefaultAnalyticsLabel, calculateTimeDifference } from '../../JS/utility'
import Loader from '../../UI/loader'
import axios from 'axios'

class MobileTv extends Component {

    constructor(props) {
        super(props)
        this.state = {
            width: 1000,
            longestslots: 0,
            showCategoryList:false,
            showLanguageList:false,
            channelList:[],
            invalidChannels: [],
            selectedCategory:"All categories",
            selectedLanguage:"All languages",
            allCategoryList: [],
            allLanguageList: [],
            categoryList: [],
            languageList:[],
            apiCalled: false,
            networkType: null,
            showNetworkUnspportedScreen: false,
            showLoader: false,
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.displayName
        }
    }

    setChannelListHandler = (chanNumList) => {

        console.log('chanNumList', chanNumList)

        if(!chanNumList){
            return;
        }

        let channels = [];

        chanNumList.map(el => {
            this.props.channelData.map(obj => {
                if(el === obj.channelNumber && obj.mobileTvUrl != ""){
                    channels.push(obj);
                }
            })
        })

        console.log("current channel list",channels);
        this.setState({channelList:channels});

        
    }

    setLanguageOptionsHandler = (categoryChannels) => {
        let filtetredLanguageOptions = []
        let i,j

        for(i=0; i<categoryChannels.length; i++ ){
            for (let x in this.state.allLanguageList) {
                if(filtetredLanguageOptions.includes(x)){
                    // break;
                }
                if(this.state.allLanguageList[x].some( ch =>  categoryChannels[i].includes(ch))){
                    filtetredLanguageOptions.push(x);
                    //  break;
                }
            }
        }

        filtetredLanguageOptions = Array.from(new Set(filtetredLanguageOptions))

        console.log('filtetredLanguageOptions',filtetredLanguageOptions)
        return filtetredLanguageOptions;
    }

    setCategoryOptionsHandler = (languageChannels) => {
        let filtetredCategoryOptions = []
        let i,j

        for(i=0; i<languageChannels.length; i++ ){
            for (let x in this.state.allCategoryList) {
                if(filtetredCategoryOptions.includes(x)){
                    // console.log('filtetredCategoryOptions.includes(x) include',filtetredCategoryOptions.includes(x), x)
                    // break;
                }
                if(this.state.allCategoryList[x].some( ch =>  languageChannels[i].includes(ch))){
                    filtetredCategoryOptions.push(x);
                    // console.log('filtetredCategoryOptions.includes(x)',filtetredCategoryOptions.includes(x), x)
                    // break;
                }
            }
        }

        filtetredCategoryOptions = Array.from(new Set(filtetredCategoryOptions))

        console.log('filtetredLanguageOptions',filtetredCategoryOptions)
        return filtetredCategoryOptions;
    }


    getwidth = () => {
        let longestslots = 0, slot = 0
        if (this.props.channelData.length > 0) {
            this.props.channelData.map((itrator) => {
                itrator.schedules.map((itr) => {
                    if (itr.duration > 59) {
                        slot = slot + 2
                    } else {
                        slot = slot + 1
                    }
                })
                if (longestslots < slot) {
                    longestslots = slot
                }
                slot = 0
            })
        } else {
            longestslots = 2
        }
        if (longestslots < 2) {
            this.setState({ width: 2 * 163.2 + 60, longestslots: 2 });
        } else {
            this.setState({ width: longestslots * 163.2 + 60, longestslots: longestslots });
        }
    }

    getToken = () => {
        let token = null
        if (this.props.roomRemoteDetails.length > 0) {
            if (this.props.currentTv.remoteSessionToken) {
                token = this.props.currentTv.remoteSessionToken
            } else {
                console.log("No remoteSessionToken found.")
            }
        } else {
            //this.props.popupOpenClose(true, "No TVs to control are found.");
            console.log("No TVs to control are found");
        }
        console.log('getToken', token);
        return token
    }

    getTimeSlots = () => {
        let hours = 0, min = 0, dateforGuide = "", period = "AM"
        let dateAndTime = ""
        let scheduledate = new Date();
        dateforGuide = `<li class="date"><div>${days[scheduledate.getDay()]} ${months[scheduledate.getMonth()]} ${scheduledate.getDate()} ${scheduledate.getFullYear()}</div></li>`
        if (this.props.channelData.length > 0) {
            hours = scheduledate.getHours()
            period = hours <= 12 ? "AM" : "PM"
            min = scheduledate.getMinutes()
            dateAndTime += `${dateforGuide}<li>${hours > 12 ? hours - 12 : hours}:${min > 20 ? 30 : "00"}${period}</li>`
            console.log('this.state.longestslots',this.state.longestslots)
            for (let i = 0; i < this.state.longestslots-1; i++) {

                if (min < 29) {
                    min = 30
                    dateAndTime += `<li>${hours > 12 ? hours - 12 : hours}:${min}${period}</li>`
                } else {
                    if (hours < 24) { hours = hours + 1 } else { hours = 0 }
                    min = 0
                    dateAndTime += `<li>${hours > 12 ? hours - 12 : hours}:${"00"}${period}</li>`
                }
            }
            //return dateAndTime
            $('#timeList').html(dateAndTime)
        } else {
            $('#timeList').html(dateforGuide)
        }

    }

    clickChannel = (channel) => {
        let token = this.getToken();
        playOnTV(token, channel.channelNumber);
    }


    componentDidUpdate(prevProps,prevState){

        try{
            if(prevState.selectedCategory !== this.state.selectedCategory || prevState.selectedLanguage !== this.state.selectedLanguage){
                if(this.state.selectedCategory !==  "All categories"  && this.state.selectedLanguage === "All languages"){
                    let filteredChannelList = this.state.allCategoryList[this.state.selectedCategory]
                    this.setChannelListHandler(filteredChannelList)
                    this.setState({
                        languageList: this.setLanguageOptionsHandler(filteredChannelList)
                    })
                    
                }else if(this.state.selectedCategory === "All categories" && this.state.selectedLanguage !== "All languages"){
                    let filteredChannelList = this.state.allLanguageList[this.state.selectedLanguage]
                    this.setChannelListHandler(filteredChannelList)
                    this.setState({
                        categoryList: this.setCategoryOptionsHandler(filteredChannelList)
                    })
                }else if(this.state.selectedCategory !== "All categories" && this.state.selectedLanguage !== "All languages"){
                    let categoryList = this.state.allCategoryList[this.state.selectedCategory];
                    let languageList = this.state.allLanguageList[this.state.selectedLanguage];
                    let arr = categoryList.filter(value => languageList.includes(value));
                    this.setChannelListHandler(arr);
                }else{
                    this.setState({channelList: this.filterMobileTvChannels(this.props.channelData).validChannelList,
                         categoryList: Object.keys(this.state.allCategoryList),
                         languageList: Object.keys(this.state.allLanguageList)});
                }
            }
        } catch (error){
            console.log('error in applying mobile filters', error)
            if(window.FirebasePlugin){
                window.FirebasePlugin.logError("error in applying mobile filters", error )
            }
        }

    }

    checkForHotelWiFi = () => {
        console.log('this.state.chanelList',this.state.chanelList)
        
        let timeout  = setTimeout(() => {
            this.setState({showNetworkUnspportedScreen: true, showLoader: false})
        }, 3000)

        checkIfImageExists(this.state.channelList.length > 0 ? this.state.channelList[0].iconUrl : null , this, (exists, self) => {
            console.log('callback from img exists', exists, self.state.channelList[0] && self.state.channelList[0].iconUrl, self.state.networkType)

            if(!exists){
                this.setState({showNetworkUnspportedScreen: true, showLoader: false})
                if(window.FirebasePlugin){
                    window.FirebasePlugin.logMessage("Channel iIcon does not exist", self.state.channelList[0].iconUrl, self.state.networkType);
                    window.FirebasePlugin.logError("Channel icon does not exist")
                }
                clearTimeout(timeout)
            } else {
                this.setState({showLoader: false})
                clearTimeout(timeout)
            }
        });
    }

    filterMobileTvChannels = (channelData) => {

        let channels = []
        let invalidChannelNumbers = new Set()

        channelData.map(obj => {
                if(obj.mobileTvUrl != ""){
                    channels.push(obj);
                } else{
                    invalidChannelNumbers.add(obj.channelNumber)
                }
        })

        this.setState({
            invalidChannels: Array.from(invalidChannelNumbers)
        })

        console.log('channels',channels)
        return {
            validChannelList: channels,
            invalidChannelNumbers: Array.from(invalidChannelNumbers)
        };
    }

    filterLanguageOptions = (languageGroup, invalidChannelNumbers) => {
        let filterOptions = {}

        for(let key in languageGroup){
            if(languageGroup[key].length > 0){
                let chanelNums = []
                languageGroup[key].forEach(n => {
                    if(!invalidChannelNumbers.includes(n)){
                        chanelNums.push(n)
                    } 
                });
                filterOptions[key] = chanelNums
            }
        }
        console.log('languageOptions',filterOptions)
        return filterOptions;
    }

    filterCategoryOptions = (categoryGroup, invalidChannelNumbers) => {
        let filterOptions = {}

        for(let key in categoryGroup){
            if(categoryGroup[key].length > 0){
                let chanelNums = []
                categoryGroup[key].forEach(n => {
                    if(!invalidChannelNumbers.includes(n)){
                        chanelNums.push(n)
                    }
                });
                if(chanelNums.length > 0){
                    filterOptions[key] = chanelNums
                }
            }
        }

        console.log('categoryOptions',filterOptions)
        return filterOptions;
    }

    goBack = () => {
        console.log('this.props.roomRemoteDetails.length',this.props.roomRemoteDetails.length)
        // if(this.props.roomRemoteDetails.length <= 1){
            this.props.setGoHome(true);
        // } else {
        //     // window.history.back(-1);
        //     this.props.setCurrentTV({})
        // }
        this.props.setMobileTVPage(false);
    }

    componentWillUnmount() {
        this.props.setChannelData([])

        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let widgetCloseTime = new Date

            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.state.widgetName, 
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //
    }

    componentDidMount() {

        let networkType = getConnectionType();
        this.setState({
            networkType:networkType
        })

        if(networkType == 'wifi'){
            this.setState({
                showLoader: true
            })
        }

        this.getwidth();
        // tvWidgetColors(this.props.menuColor)
        let sessionToken = localStorage.getItem("GuestJourneySessionToken");
        let chanSchHours = parseInt(this.props.channelScheduleHours);
        if (sessionToken && chanSchHours) {

            this.props.fetchChannelList("/Ipg/ChannelData", chanSchHours, sessionToken, (bool) => {
                                let channelsObj = this.filterMobileTvChannels(this.props.channelData)
                                let filteredCategoryList = this.filterCategoryOptions(this.props.categoryGrouping, channelsObj.invalidChannelNumbers)
                                let filteredLanguageList = this.filterLanguageOptions(this.props.languageGrouping, channelsObj.invalidChannelNumbers)

                                this.setState({channelList: channelsObj.validChannelList,
                                        categoryList: Object.keys(filteredCategoryList), languageList: Object.keys(filteredLanguageList),
                                        allCategoryList: filteredCategoryList, allLanguageList: filteredLanguageList, apiCalled: bool }
                                , this.checkForHotelWiFi
                                )});
                                    
        } else {
            console.log("There is no channelScheduleHours or sessionToken")
        }        

        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgetOb.displayName, 
                CLICKED, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //

    }

    render() {
        const { t } = this.props
        return (
            <Fragment>
                <header class="inner-pages w-footer subpages"
                style={{
                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                }}>
                    <a onClick={this.goBack} class="button-back"
                    //style="display: none;"
                    ></a>
                    <div class="heading align-center">
                        <p class="bold" style={{
                            color:this.props.menuColor.assetFontSelectorColor,
                            textShadow:"unset"
                        }}>Mobile TV</p>
                    </div>
                </header>
                <section id="tvControls" class="widgets padding-0 margin-0 container-bg">
                { !(this.state.networkType !== "wifi" || this.state.showNetworkUnspportedScreen) && 
                    <div class="widgets">
                        <div class="row padding-left-2 padding-right-2 multi-select">
                            <div class="tv-genre tile tile-container custom-select" style = {{
                                backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                            }}>
                                <div className="select-selected" onClick={() => this.setState(prev => ({showCategoryList:!prev.showCategoryList}))}
                                style = {{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}}>
                                    {this.state.selectedCategory}
                                </div>
                                <div className={`select-items ${this.state.showCategoryList ? "" : "select-hide"}`}>
                                    <div onClick={() => {this.setState({selectedCategory:"All categories",showCategoryList:false})}}>{this.props.t('room_control.tv_control.all_catagory')}</div>
                                    {this.state.categoryList.map((el,index) => {
                                        return(<div key = {index} onClick={() => {this.setState({selectedCategory:el,showCategoryList:false})}}>{el}</div>)
                                    })}
                                </div>
                            </div>
                            <div class="tv-lang tile tile-container custom-select" style = {{
                                backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                            }}>
                                <div className="select-selected" onClick={() => this.setState(prev => ({showLanguageList: !prev.showLanguageList}))}
                                style = {{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}}>
                                    {this.state.selectedLanguage}
                                </div>
                                <div className={`select-items ${this.state.showLanguageList ? "" : "select-hide"}`}>
                                    <div onClick={() => {this.setState({selectedLanguage:"All languages",showLanguageList:false})}}>{this.props.t('room_control.tv_control.all_lang')}</div>
                                    {this.state.languageList.map((el,index) => {
                                        return(<div key = {index} onClick={() => {this.setState({selectedLanguage:el,showLanguageList:false})}}>{el}</div>)
                                    })}
                                </div>
                            </div>
                        </div>
                        <div class="row padding-left-2 padding-right-2 ch-list">
                            <div class="ch-list-label">
                                <div class={`ch-list-time ${this.props.currentWidgetOb.widgetType === "EPG" ? "" : "no-epg"}`}>
                                    {this.props.currentWidgetOb.widgetType === "EPG" && <ul id="timeList" style={{ width: this.state.width }}>
                                        {this.getTimeSlots()}
                                        {/* <li class="date">June 11</li>
                                        <li>21:30</li>
                                        <li>22:00</li>
                                        <li>22:30</li>
                                        <li>23:00</li>
                                        <li>23:30</li>
                                        <li>00:00</li> */}
                                    </ul>}
                                { this.state.channelList.length > 0 ?
                                    <div class="ch-list-menu" style={this.props.currentWidgetOb.widgetType === "EPG" ? { width: this.state.width } : {}}>
                                        {
                                            this.state.channelList.map((itrator) => {
                                                return (
                                                    <div class="ch-list-menu-row" onClick={() => streamChannel(itrator.mobileTvUrl, this.props, itrator.channelName)}>
                                                        <div class="ch-list-logo-container">
                                                            <div class="ch-list-logo"
                                                                style={{ background: `url('${itrator.iconUrl ? itrator.iconUrl : ""}') center center no-repeat`, backgroundSize: "contain" }}
                                                            >
                                                                {
                                                                    // !itrator.iconUrl ?
                                                                    //     <img src={DefaultIcon} /> : ""
                                                                }

                                                            </div>
                                                        </div>
                                                        {
                                                            this.props.currentWidgetOb.widgetType === "EPG" ? 

                                                            itrator.schedules.length > 0 ?
                                                                itrator.schedules.map((itr) => {
                                                                    return (
                                                                        <div class={`ch-list-menu-item ${itr.duration > 59 ? "time-full-hour" : "time-half-hour"}`}>
                                                                            <div class="ch-list-desc">
                                                                                <span class="title">{itr.title}</span>
                                                                                <span class="desc">{itr.descLong}</span>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }) :
                                                                <div class="ch-list-menu-item time-full-hour">
                                                                    <div class="ch-list-desc">
                                                                        <span class="title">{itrator.channelName}</span>
                                                                        <span class="desc"></span>
                                                                    </div>
                                                                </div>

                                                            : <div class="ch-list-menu-item">
                                                            <div class="ch-list-desc">
                                                                <span class="title">{itrator.channelName}</span>
                                                                <span class="desc" style={{overflow: "initial",whiteSpace: "normal"}}></span>
                                                            </div>
                                                        </div>
                                                        }
                                                        {
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    : ( this.state.apiCalled || this.props.channelData.length > 0 ) && <p style={{textAlign: 'center', background: '#fff', color: '#000', padding: '6em'}}>Channels not found</p>
                                }
                                </div>
                            </div>
                        </div>
                    </div> }
                </section>
                {
                    (this.state.networkType !== "wifi" || this.state.showNetworkUnspportedScreen) && <SuccessFailScreen showStatusTitle={false} tryAgain={this.goBack} status={false} showTryAgain={true} showClose={false} statusMessage1={<div>Cannot show  &nbsp; channel list.<br/>Please make sure you are<br/>connected to the<br/>Hotel Wi-Fi</div>} tryAgainButtonTexts="Return to previous page" />
                }
                {
                    this.state.showLoader && <Loader displayMsg="Fetching channel list" />
                }
            </Fragment>        )
    }
}

const mapStateToProps = state => {
    return {
        channelData: state.store.tvChannels.channelData,
        languageGrouping: state.store.tvChannels.languageGrouping ? state.store.tvChannels.languageGrouping : {},
        categoryGrouping: state.store.tvChannels.categoryGrouping ? state.store.tvChannels.categoryGrouping : {},
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        menuColor: state.store.home.MenuColor,
        currentTv: state.store.tvChannels.currentTv,
        currentWidgetOb: state.store.sideNavBar.currentWidget,
        channelScheduleHours: state.store.home.clientConfig.ipgExtraInfo ?
        state.store.home.clientConfig.ipgExtraInfo.ipgBrandingInfo.channelScheduleHours : "0",
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        minimumChannelWatchDuration: state.store.minimumChannelWatchDuration,
        currentHomePage: state.store2.currentHomePage,
    }
}
export default connect(
    mapStateToProps,
    {
        setCurrentTV,
        setGoHome,
        setMobileTVPage,
        fetchChannelList,
        popupOpenClose,
        setRegPage,
        setChannelData,
        sendAnalytics
    }
)(withTranslation('translations')(MobileTv));